// CNIL rules configuration
export const rules = [{
  name: 'min',
  label: 'Au moins 8 caractères',
}, {
  name: 'lowercase',
  label: 'Au moins 1 minuscule',
}, {
  name: 'uppercase',
  label: 'Au moins 1 majuscule',
}, {
  name: 'digits',
  label: 'Au moins 1 chiffre',
}];

export const intervalGetPropagation = window.reactAppEnv.apiRules.intervalPropagation;
